module.exports = __webpack_public_path__ + "img/banner.fd64e90b.png";